import { render } from "./App.vue?vue&type=template&id=5c6edc48&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5c6edc48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c6edc48"

export default script